import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import Chakra from './Chakra';
import './CinematicIntro.css';

function CinematicIntro({ onComplete }) {
  const introRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const chakraRef = useRef(null);
  const curtainLeftRef = useRef(null);
  const curtainRightRef = useRef(null);
  const enterBtnRef = useRef(null);

  useEffect(() => {
    // Initial entrance animation timeline
    const tl = gsap.timeline({
      defaults: { ease: 'power3.out', duration: 1.2 }
    });

    tl.fromTo(chakraRef.current, 
      { scale: 0, rotation: -180, opacity: 0 }, 
      { scale: 1, rotation: 0, opacity: 1, duration: 1.5, ease: 'back.out(1.7)' }
    )
    .fromTo(titleRef.current, 
      { y: 50, opacity: 0 }, 
      { y: 0, opacity: 1 }, 
      '-=0.8'
    )
    .fromTo(subtitleRef.current, 
      { y: 30, opacity: 0 }, 
      { y: 0, opacity: 1 }, 
      '-=0.6'
    )
    .fromTo(enterBtnRef.current, 
      { scale: 0.8, opacity: 0 }, 
      { scale: 1, opacity: 1, ease: 'elastic.out(1, 0.5)' }, 
      '-=0.4'
    );

    // Continuous soft spin for the Ashoka Chakra
    gsap.to(chakraRef.current, {
      rotation: 360,
      duration: 20,
      repeat: -1,
      ease: 'none'
    });
  }, []);

  const handleEnter = () => {
    // Exit animation timeline
    const exitTl = gsap.timeline({
      onComplete: () => {
        if (onComplete) onComplete();
      }
    });

    exitTl.to([titleRef.current, subtitleRef.current, enterBtnRef.current, chakraRef.current], {
      opacity: 0,
      y: -50,
      duration: 0.6,
      stagger: 0.1,
      ease: 'power3.in'
    })
    .to(curtainLeftRef.current, {
      xPercent: -100,
      duration: 1,
      ease: 'power4.inOut'
    }, '-=0.2')
    .to(curtainRightRef.current, {
      xPercent: 100,
      duration: 1,
      ease: 'power4.inOut'
    }, '<')
    .to(introRef.current, {
      opacity: 0,
      duration: 0.3,
      pointerEvents: 'none'
    }, '-=0.5');
  };

  return (
    <div className="cinematic-intro" ref={introRef}>
      {/* Cinematic Curtains */}
      <div className="curtain curtain--left" ref={curtainLeftRef} />
      <div className="curtain curtain--right" ref={curtainRightRef} />
      
      {/* Particles Overlay */}
      <div className="particles-bg" />

      {/* Intro Content */}
      <div className="cinematic-intro__content">
        <div className="cinematic-intro__chakra-wrapper" ref={chakraRef}>
          <Chakra size={120} color="#ffffff" className="cinematic-intro__chakra" />
        </div>
        
        <h1 className="cinematic-intro__title" ref={titleRef}>
          <span className="text-saffron">Aspirations</span>{' '}
          <span className="text-white">Of A</span>{' '}
          <span className="text-green">Free Nation</span>
        </h1>
        
        <p className="cinematic-intro__subtitle" ref={subtitleRef}>
          Celebrating India's Independence Day. Experience Acrlios engineering built with the spirit of absolute freedom.
        </p>

        <button 
          className="cinematic-intro__btn" 
          ref={enterBtnRef}
          onClick={handleEnter}
        >
          <span>ENTER THE EXPERIENCE</span>
          <div className="btn-glow-effect" />
        </button>
      </div>
    </div>
  );
}

export default CinematicIntro;
